import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

// Fetch comments
export async function getComments({ boardId, params, signal } = {}) {
  try {
    const ret = await axios.get(`${await API_URL()}/comments/${boardId}`, {
      headers: { ...(await getAuthHeader()) },
      params,
      signal
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    if (axios.isCancel(error)) return null
    logger.error(error.message)
    return { error: error.response?.status || 0 }
  }
}

export async function getCommentCounts({ boardId }) {
  try {
    const ret = await axios.get(`${await API_URL()}/comments/${boardId}/counts`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    return null
  }
}

// Add a comment
export async function addComment({ boardId, comment }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/comments/${boardId}`,
      { data: { comment } },
      {
        headers: { ...(await getAuthHeader()) }
      }
    )

    if (ret.status === 201) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

// Update a comment
export async function updateComment({ boardId, comment }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/comments/${boardId}/update`,
      { data: { comment } },
      {
        headers: { ...(await getAuthHeader()) }
      }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}

// Delete a comment
export async function deleteComment({ boardId, commentId }) {
  try {
    const ret = await axios.delete(`${await API_URL()}/comments/${boardId}/${commentId}`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.error(error.message)
    throw error
  }
}
